export enum BancoIntegracaoEnum {
  SICOOB = 'SICOOB',
  BRADESCO = 'BRADESCO',
  BANCO_DO_BRASIL = 'BANCO_DO_BRASIL',
  CAIXA = 'CAIXA',
  ITAU = 'ITAU',
  SANTANDER = 'SANTANDER',
  SICREDI = 'SICREDI',
  OUTRO = 'OUTRO',
}

export enum TipoContaCorrenteEnum {
  CORRENTE = 'CORRENTE',
  POUPANCA = 'POUPANCA',
  CAIXA = 'CAIXA',
}

export enum CnabPadraoEnum {
  CNAB240 = 'CNAB240',
  CNAB400 = 'CNAB400',
}

export interface BancoIntegracaoInfo {
  codigo: BancoIntegracaoEnum;
  codigoFebraban: string;
  nome: string;
  suportaApi: boolean;
  /** Quando false, a API do banco autentica apenas com Client ID (ex.: Sicoob). */
  exigeClientSecret?: boolean;
  tokenUrl?: string;
  boletoUrl?: string;
  pixCobUrl?: string;
  scope?: string;
}

export const BANCOS_INTEGRACAO: BancoIntegracaoInfo[] = [
  {
    codigo: BancoIntegracaoEnum.SICOOB,
    codigoFebraban: '756',
    nome: 'Sicoob',
    suportaApi: true,
    exigeClientSecret: false,
  },
  { codigo: BancoIntegracaoEnum.BRADESCO, codigoFebraban: '237', nome: 'Bradesco', suportaApi: false },
  { codigo: BancoIntegracaoEnum.BANCO_DO_BRASIL, codigoFebraban: '001', nome: 'Banco do Brasil', suportaApi: false },
  { codigo: BancoIntegracaoEnum.CAIXA, codigoFebraban: '104', nome: 'Caixa Econômica', suportaApi: false },
  { codigo: BancoIntegracaoEnum.ITAU, codigoFebraban: '341', nome: 'Itaú', suportaApi: false },
  { codigo: BancoIntegracaoEnum.SANTANDER, codigoFebraban: '033', nome: 'Santander', suportaApi: false },
  { codigo: BancoIntegracaoEnum.SICREDI, codigoFebraban: '748', nome: 'Sicredi', suportaApi: false },
  { codigo: BancoIntegracaoEnum.OUTRO, codigoFebraban: '000', nome: 'Outro', suportaApi: false },
];

export const DescricaoBanco = new Map<BancoIntegracaoEnum, string>(
  BANCOS_INTEGRACAO.map(b => [b.codigo, b.nome]),
);

export const DescricaoTipoConta = new Map<TipoContaCorrenteEnum, string>([
  [TipoContaCorrenteEnum.CORRENTE, 'Corrente'],
  [TipoContaCorrenteEnum.POUPANCA, 'Poupança'],
  [TipoContaCorrenteEnum.CAIXA, 'Caixa'],
]);

export function infoBanco(codigo: string | null | undefined): BancoIntegracaoInfo | undefined {
  if (!codigo) {
    return undefined;
  }
  return BANCOS_INTEGRACAO.find(b => b.codigo === codigo);
}

export function labelBanco(codigo: string | null | undefined): string {
  const info = infoBanco(codigo);
  return info?.nome ?? codigo ?? '';
}
